import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges, input } from '@angular/core';
import { AgCharts } from 'ag-charts-angular';
import { AgChartOptions } from 'ag-charts-community';
import { NgIf, isPlatformBrowser } from '@angular/common';

import { DirectSessionLogicService } from '../../../../shared/direct-session-logic.service';
import { KnownSteps } from '../../../../shared/models/session.model';

@Component({
    selector: 'app-ag-radial-pie-graph',
    template: `
        <ag-charts *ngIf="isBrowser" 
            [options]="chartOptions" 
            class="radial-pie-adjustment"
            >
        </ag-charts> 
    `,  
    styleUrls: ['./ag-radial-pie-graph.component.scss'],
    standalone: true,
    imports: [ NgIf, AgCharts ],

})
export class CircleStepperComponent implements OnInit{
    
    @Input() completedSteps !: number;
    @Input() maxSteps !: number;
    @Input() stepsList !: KnownSteps[];


    public chartOptions !: AgChartOptions;
    public isBrowser: boolean;
    public currentStep: number = 0;


    graphData: any;


    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        public directSessionLogic: DirectSessionLogicService,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);

    }

    ngOnInit(): void{
        this.generateGraphData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.chartOptions = this.getChartOptions();   

        if(this.stepsList.length > 0) this.generateGraphData();
    }


    generateGraphData(){
        this.completedSteps = this.stepsList.filter(step => step.completed === true).length;
        this.maxSteps = this.stepsList.length;

        
        this.chartOptions = this.getChartOptions();
    }

    getChartOptions() : AgChartOptions {
        return{
            data: //this.getData(),
            [
                { value: this.completedSteps},
                { value: this.maxSteps-this.completedSteps}
                
            ],
            background: {
                visible: false
            },
            width: 120,
            height: 120,
            series: [{ 
                // responsive: true,
                type: "donut",
                angleKey: "value",
                outerRadiusRatio: 1,
                innerRadiusRatio: 0.8,
                cornerRadius: 10,
                fills: ['#2563EB','white'],
                tooltip:{enabled: false},
                highlightStyle : {
                    item: {
                        fill: undefined,
                        strokeWidth: undefined,
                    }
                },
                innerLabels: [
                    {
                        text: this.completedSteps + '/' + this.maxSteps,
                        // spacing: 4,
                        fontSize: 20,
                        // fontWeight: 'bold',
                        color: 'white',
                    },
                ],
            }]
        }
    }

}